// extracted by mini-css-extract-plugin
export var navbarLang = "language-list-module--navbar-lang--kyoMd";
export var navbarDropdown = "language-list-module--navbar-dropdown--cvpfB";
export var navbarLangCurrent = "language-list-module--navbar-lang-current--y-kgj";